import type { DraftSummary, VendorModuleType } from './types';

/**
 * Source-of-truth ordering of module-detail steps inside the onboarding
 * flow. Vendors with multiple module_types walk these in order between
 * the uploads step and the terms step.
 */
// ADOPTION stays listed here even though it can no longer be SELECTED: a draft
// created before it was retired still has the module, and dropping the step
// would strand that vendor with an application they cannot complete.
export const MODULE_STEP_ORDER: VendorModuleType[] = [
  'CAFE',
  'WALKER',
  'TRAINER',
  'GROOMER',
  'RESTAURANT',
  'PHARMACY',
  'FOOD',
  'ADOPTION',
  'CREMATION',
  'LAB',
  'VET',
];

/** Modules that do NOT have a module-details endpoint (skip them). */
export const MODULES_WITHOUT_DETAILS: VendorModuleType[] = ['CLINIC'];

export function module_steps_for_draft(
  draft: DraftSummary | null | undefined,
): VendorModuleType[] {
  if (!draft) return [];
  return MODULE_STEP_ORDER.filter((m) => draft.module_types.includes(m));
}

/**
 * Module-type → URL slug. Most modules use the lowercased enum value
 * directly (RESTAURANT → restaurant, matching the backend route/folder name).
 */
const MODULE_SLUG_OVERRIDES: Partial<Record<VendorModuleType, string>> = {};

export function module_slug(m: VendorModuleType): string {
  return MODULE_SLUG_OVERRIDES[m] ?? m.toLowerCase();
}

export function module_path(m: VendorModuleType): string {
  return `/onboarding/module-details/${module_slug(m)}`;
}

export function next_module_step_after(
  current: VendorModuleType | null,
  module_types: VendorModuleType[],
): string {
  const ordered = MODULE_STEP_ORDER.filter((m) => module_types.includes(m));
  const i = current ? ordered.indexOf(current) : -1;
  const next = ordered[i + 1];
  if (next) return module_path(next);
  // Payout sits between the module details and terms: it is the last thing we need from them,
  // and putting it before terms means they agree to the fee schedule knowing where money lands.
  return '/onboarding/payout';
}
